/**
 * HeroPoster — the no-WebGL / low-power branch. A single composed still
 * representing the unfolded threshold view. Includes a real h1 + CTA so this
 * branch has the same SEO + a11y floor as the cinematic branch.
 *
 * MVP poster is an inline SVG composition. Phase 2 ships a real photographic
 * WebP/AVIF poster commissioned alongside the fly-through sequence.
 */
export function HeroPoster() {
  return (
    <section className="hero hero--poster" data-scene="cinema">
      <div className="hero-poster-art" aria-hidden="true">
        <PosterSvg />
      </div>
      <div className="hero-copy hero-copy--static">
        <p className="eyebrow">Brian Ellison Design — Melbourne, Florida</p>
        <h1 className="hero-copy__headline">
          Interiors composed like<br />
          <span className="display-italic">architecture</span>.
        </h1>
        <p className="subtitle">
          Multidisciplinary luxury interior design. Residential, commercial, and hospitality
          projects across Brevard County and beyond.
        </p>
        <a href="/projects" className="cta-primary">See the work</a>
      </div>
    </section>
  );
}

/** Inline-SVG placeholder for the hero poster image. */
function PosterSvg() {
  return (
    <svg
      viewBox="0 0 1920 1080"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
      width="100%"
      height="100%"
    >
      <defs>
        <radialGradient id="warmGlow" cx="0.5" cy="0.6" r="0.6">
          <stop offset="0" stopColor="#f5dcb4" stopOpacity="0.8" />
          <stop offset="0.6" stopColor="#704d28" stopOpacity="0.4" />
          <stop offset="1" stopColor="#0a0805" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="floorGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#1a1410" />
          <stop offset="1" stopColor="#0a0805" />
        </linearGradient>
      </defs>

      <rect width="1920" height="1080" fill="#0a0805" />

      {/* Warm interior glow visible through the open monolith */}
      <ellipse cx="960" cy="540" rx="600" ry="380" fill="url(#warmGlow)" />

      {/* Floor */}
      <rect x="0" y="820" width="1920" height="260" fill="url(#floorGrad)" />

      {/* Monolith panels — rendered as 5 angled rectangles */}
      <g transform="translate(960, 540)">
        {[
          { x: -1056, rot: -42, fill: '#704d28' },
          { x: -634,  rot: -28, fill: '#3d2818' },
          { x: -212,  rot: -8,  fill: '#0d0905' },
          { x: 210,   rot: 18,  fill: '#d4c8b4' },
          { x: 632,   rot: 34,  fill: '#a8967a' },
        ].map((p, i) => (
          <rect
            key={i}
            x={p.x}
            y={-340}
            width="180"
            height="680"
            fill={p.fill}
            stroke="rgba(212,165,116,0.35)"
            strokeWidth="1.5"
            transform={`rotate(${p.rot} ${p.x} 0)`}
            opacity="0.94"
          />
        ))}
      </g>
    </svg>
  );
}
